var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from 'react';
import Icon from '@alife/next-icon';
var CardResend = (function (_super) {
    __extends(CardResend, _super);
    function CardResend() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CardResend.prototype.render = function () {
        var _a = this.props, _b = _a.locale, locale = _b === void 0 ? {} : _b, onResend = _a.onResend, onDelete = _a.onDelete, templateData = _a.templateData;
        var token = locale.failedStatus || 'Message failed to send. {resend} or {delete}';
        var resendTxt = locale.resend || 'resend';
        var deleteTxt = locale.delete || 'delete';
        var _c = __read(token.split(/{resend}|{delete}/), 3), part1 = _c[0], part2 = _c[1], _d = _c[2], part3 = _d === void 0 ? '' : _d;
        var targetId = templateData.targetId;
        return React.createElement("div", { className: "lzd-system-text" },
            React.createElement(Icon, { type: "prompt", className: "error-icon", style: { color: 'red' } }),
            "\u00A0",
            part1,
            React.createElement("span", { onClick: function () { return onResend(targetId); }, className: "btn-text" }, resendTxt),
            part2,
            React.createElement("span", { onClick: function () { return onDelete(targetId); }, className: "btn-text" }, deleteTxt),
            part3);
    };
    return CardResend;
}(React.Component));
export default CardResend;

//# sourceMappingURL=index.js.map
